module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa3.1e567034b7da848f2f30bb4cee657d39.png";